import { Text, View } from "@react-pdf/renderer";
import { useOldDate } from "../../hooks/useOldDate";
import { ScoreBG, ScoreColor, ScoreNum } from "../../interfaces/interfaces";
import { globalStyles } from "./DocuPdf";
import { InitialPallets } from "../../interfaces/intakes.reports";

interface DataBox {
    pallet: InitialPallets
    date: Date
}

export const DataBox = ({ pallet, date }: DataBox) => {

    const { oldDate, scoreNumber } = useOldDate(date, pallet.score)

    const bgColor = ScoreBG[`score${scoreNumber as ScoreNum}`] 
    const scoreColor = ScoreColor[`score${scoreNumber as ScoreNum}`] 

    return (
        <View style={[globalStyles.flexCenter, { width: 90, borderRadius: 8, backgroundColor: bgColor, alignItems: 'center' }]}>
            {
                <Text style={[globalStyles.bold, { fontSize: '10px', color: scoreColor }]}>
                    {`${pallet.score as ScoreNum} of ${oldDate ? "5" : "8"}`}
                </Text>

            }
        </View>
    )
};